import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserBasicByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type GetUserBasicByIdQuery = { __typename?: 'query_root', users_by_pk: Array<{ __typename?: 'users', id: string, first_name: string, last_name: string, email: string, phone_number?: string | null, workspace_id?: any | null, organization_id?: any | null, role?: string | null, deleted_at?: any | null }> };


export const GetUserBasicByIdDocument = gql`
    query getUserBasicById($id: String!) {
  users_by_pk: users(where: {id: {_eq: $id}}) {
    id
    first_name
    last_name
    email
    phone_number
    workspace_id
    organization_id
    role
    deleted_at
  }
}
    `;

/**
 * __useGetUserBasicByIdQuery__
 *
 * To run a query within a React component, call `useGetUserBasicByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserBasicByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserBasicByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserBasicByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserBasicByIdQuery, GetUserBasicByIdQueryVariables> & ({ variables: GetUserBasicByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserBasicByIdQuery, GetUserBasicByIdQueryVariables>(GetUserBasicByIdDocument, options);
      }
export function useGetUserBasicByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserBasicByIdQuery, GetUserBasicByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserBasicByIdQuery, GetUserBasicByIdQueryVariables>(GetUserBasicByIdDocument, options);
        }
export function useGetUserBasicByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserBasicByIdQuery, GetUserBasicByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserBasicByIdQuery, GetUserBasicByIdQueryVariables>(GetUserBasicByIdDocument, options);
        }
export type GetUserBasicByIdQueryHookResult = ReturnType<typeof useGetUserBasicByIdQuery>;
export type GetUserBasicByIdLazyQueryHookResult = ReturnType<typeof useGetUserBasicByIdLazyQuery>;
export type GetUserBasicByIdSuspenseQueryHookResult = ReturnType<typeof useGetUserBasicByIdSuspenseQuery>;
export type GetUserBasicByIdQueryResult = Apollo.QueryResult<GetUserBasicByIdQuery, GetUserBasicByIdQueryVariables>;